import * as tslib_1 from "tslib";
import { DateTime } from 'luxon';
import humanize from 'humanize-duration';
import { Model } from '@app/models/model';
import { config } from '@config/config';
import { Query } from '@app/models/queries/queries.model';
import { COLOR_CONSTANTS } from '../../shared/scss-variables.generated';
var COLORS = {
    RED: COLOR_CONSTANTS['$red-clay'],
    ORANGE: COLOR_CONSTANTS['$sunset'],
    GREEN: COLOR_CONSTANTS['$cut-grass'],
};
var Notification = /** @class */ (function (_super) {
    tslib_1.__extends(Notification, _super);
    function Notification(input) {
        var _this = _super.call(this, input) || this;
        _this.flowRate = 'N/A';
        _this.duration = 'N/A';
        _this.formatColor();
        _this.formatType();
        _this.formatCreated();
        _this.formatUsageQuery();
        _this.formatDuration();
        return _this;
    }
    Notification.prototype.formatColor = function () {
        if (this.type === config.notificationTypes.USAGE_ALERT) {
            this.hexColor = this.title.indexOf('Leak') > -1 ? COLORS.RED : COLORS.ORANGE;
        }
        else if (this.type === config.notificationTypes.BUDGET) {
            this.hexColor =
                this.extra.percentage >= 100
                    ? COLORS.RED
                    : this.extra.percentage < 75
                        ? COLORS.GREEN
                        : COLORS.ORANGE;
        }
        else if (this.type === config.notificationTypes.HEARTBEAT) {
            if (this.extra && this.extra.connected) {
                this.hexColor = COLORS.GREEN;
            }
            else {
                this.hexColor = COLORS.RED;
            }
        }
        else if (this.type === config.notificationTypes.BATTERY ||
            this.type === config.notificationTypes.DEVICE_MOVED) {
            this.hexColor = COLORS.RED;
        }
        else {
            this.hexColor = COLORS.GREEN;
        }
    };
    Notification.prototype.formatType = function () {
        if (this.type === config.notificationTypes.USAGE_ALERT) {
            this.typeString = this.event_rule ? this.event_rule + " Usage Alert" : 'Usage Alert';
        }
        else {
            this.typeString = config.notificationTypeFormat[this.type];
        }
    };
    Notification.prototype.formatCreated = function () {
        this.createdString = DateTime.fromISO(this.created_datetime).toLocaleString(DateTime.DATETIME_MED);
    };
    Notification.prototype.formatUsageQuery = function () {
        if (this.extra && this.extra.query) {
            var q = this.extra.query;
            this.usageQuery = new Query({
                device_id: this.device_id,
                since_datetime: q.since_datetime,
                until_datetime: q.until_datetime,
                bucket: q.bucket,
                group_multiplier: 1,
                operation: 'AVG',
            });
        }
    };
    Notification.prototype.formatDuration = function () {
        if (this.type === config.notificationTypes.USAGE_ALERT && this.extra && this.extra.query) {
            this.duration = humanize(DateTime.fromSQL(this.extra.query.until_datetime).diff(DateTime.fromSQL(this.extra.query.since_datetime), 'milliseconds').milliseconds, { largest: 1, round: true });
        }
    };
    Notification.prototype.calculateFlowRate = function () {
        if (this.usageQuery && (this.usageQuery.value || this.usageQuery.value === 0)) {
            this.flowRate = this.usageQuery.value.toFixed(2) + " gal / min";
        }
    };
    Notification.prototype.calculateDuration = function () {
        if (this.type === config.notificationTypes.HEARTBEAT && this.device) {
            var dur = DateTime.fromISO(this.device.last_seen).diff(DateTime.fromISO(this.created_datetime), 'milliseconds').milliseconds;
            if (dur > 600000) {
                this.duration = humanize(dur, { largest: 1, round: true });
            }
            else {
                this.duration = 'Unresolved';
            }
        }
    };
    return Notification;
}(Model));
export { Notification };
